import { assign } from "xstate";
import { AR_SUPPORT, PAGES, XR_MODES } from "../constants";
import { AR_PLATFORM_SM } from "./ARPlatformSM";
import { XR_SM } from "./XRSM";
import WaitSM from "./WaitSM";
import {
  downloaderSequence,
  executeInSequence,
  getClientIdFromURL,
  getParamsFromURL,
} from "../modules/MachineUtils";

export const RENDERER_SM_CONST = {
  // States
  MODE_ANALYSE: "MODE_ANALYSE",
  AR_CAPABILITY_ANALYSE: "AR_CAPABILITY_ANALYSE",
  AR: "AR",
  QR: "QR",
  XR: "XR",
  // Misc
  ID: "RENDERER_SM",
};

const arXrTarget = (actions, xrMode, cond = () => true) => ({
  target:
    xrMode === XR_MODES.XR
      ? RENDERER_SM_CONST.XR
      : RENDERER_SM_CONST.AR_CAPABILITY_ANALYSE,
  actions: [
    () => actions.ARControllerUIState().setXRMode(xrMode),
    () => actions.ARPlatform.updateSearchParams(xrMode),
  ],
  cond,
});

const modeListner = (actions) => {
  return (mode) => {
    console.log("rendererMode", mode);
    const Mode = parseInt(mode, 10) === 1 ? XR_MODES.AR : XR_MODES.XR;
    console.log("mode", Mode);
    actions.Event.sendSMEvent(Mode);
  };
};

export const RENDERER_SM = (actions, skuId) => ({
  id: RENDERER_SM_CONST.ID,
  initial: RENDERER_SM_CONST.MODE_ANALYSE,
  context: {},
  states: {
    [RENDERER_SM_CONST.MODE_ANALYSE]: {
      entry: [
        () => {
          const IS_IOS =
            typeof navigator !== "undefined" &&
            (/iPad|iPhone|iPod/.test(navigator.userAgent || "") ||
              (navigator.platform === "MacIntel" &&
                navigator.maxTouchPoints > 1));

          if (IS_IOS) {
            window.createImageBitmap = undefined;
          }
        },
        assign({
          skuId,
          clientId: getClientIdFromURL(actions),
          preprod: getParamsFromURL(actions.window, "preprod"),
          mode: getParamsFromURL(actions.window, "mode"),
        }),
        () =>
          actions.useListnerStore
            .getState()
            .setModeListner(modeListner(actions)),
        () => actions.ARPlatform.startCheckSupport(),
        () => actions.RendererState().setPage(PAGES.LOADING),
        () => actions.ARPlatform.checkURLForAR(),
        (context) => {
          console.log("calling execute in seq", context);
          executeInSequence(downloaderSequence(actions, context));
        },
        () => actions.Event.sendSMEvent(actions.ARPlatform.checkURLForAR()),
      ],
      on: {
        [XR_MODES.AR]: arXrTarget(actions, XR_MODES.AR),
        [XR_MODES.XR]: arXrTarget(actions, XR_MODES.XR),
      },
    },
    [RENDERER_SM_CONST.AR_CAPABILITY_ANALYSE]: {
      entry: [() => actions.RendererState().setPage(PAGES.LOADING)],
      ...WaitSM({
        conds: [
          () => actions.ARPlatform.getSupport() !== AR_SUPPORT.INITIALIZING,
        ],
        events: [AR_SUPPORT.SUPPORTED, AR_SUPPORT.NOT_SUPPORTED],
      }),
      onDone: [
        {
          target: RENDERER_SM_CONST.AR,
          cond: () => actions.ARPlatform.getSupport() === AR_SUPPORT.SUPPORTED,
        },
        {
          target: RENDERER_SM_CONST.QR,
          cond: () =>
            actions.ARPlatform.getSupport() === AR_SUPPORT.NOT_SUPPORTED,
        },
      ],
    },
    [RENDERER_SM_CONST.QR]: {
      entry: [
        () => actions.RendererState().setPage(PAGES.QR_CODE),
        () => actions.ARControllerUIState().setEnableARSwitch(true),
      ],
      on: {
        [XR_MODES.XR]: arXrTarget(actions, XR_MODES.XR),
      },
    },
    [RENDERER_SM_CONST.AR]: {
      exit: [
        () => actions.ARPlatform.getPlatformModule().stopAR(),
        () =>
          actions.useButtonConfigStore
            .getState()
            .setUIConfig({ submenu: false }),
      ],
      on: {
        // [XR_MODES.XR]: arXrTarget(actions, XR_MODES.XR),
        [XR_MODES.XR]: [
          {
            target: "RELOAD_TO_XR",
            cond: () => {
              const skuConfig = actions.ConfigLoader.getSKUConfig(skuId);
              return skuConfig && skuConfig.version === "V0";
            },
          },
          arXrTarget(actions, XR_MODES.XR, () => {
            const skuConfig = actions.ConfigLoader.getSKUConfig(skuId);
            return skuConfig && skuConfig.version !== "V0";
          }),
        ],
      },
      ...AR_PLATFORM_SM(actions, skuId),
    },
    [RENDERER_SM_CONST.XR]: {
      entry: [() => actions.RendererState().setPage(PAGES.XR)],
      exit: [
        // () => actions.ThreejsScene.removeSceneFromDOM(),
        () =>
          actions.useButtonConfigStore
            .getState()
            .setUIConfig({ submenu: false }),
        // () => actions.ThreejsScene.hideScene(true),
      ],
      on: {
        // [XR_MODES.AR]: arXrTarget(actions, XR_MODES.AR),
        [XR_MODES.AR]: [
          {
            target: "RELOAD_TO_AR",
            cond: () => {
              const skuConfig = actions.ConfigLoader.getSKUConfig(skuId);
              return skuConfig && skuConfig.version === "V0";
            },
          },
          arXrTarget(actions, XR_MODES.AR, () => {
            const skuConfig = actions.ConfigLoader.getSKUConfig(skuId);
            return skuConfig && skuConfig.version !== "V0";
          }),
        ],
      },
      ...XR_SM(actions, skuId),
    },
    RELOAD_TO_AR: {
      entry: [
        () => {
          console.log("window.location", window.location.href);
          actions.RendererState().setPage(PAGES.XR);
          const url = new URL(window.location);
          url.searchParams.set("ar", 1);
          window.location.href = url.href;
        },
      ],
    },
    RELOAD_TO_XR: {
      entry: [
        () => {
          console.log("window.location", window.location.href);
          actions.RendererState().setPage(PAGES.AR);
          const url = new URL(window.location);
          url.searchParams.set("ar", 0);
          window.location.href = url.href;
        },
      ],
    },
  },
});
